import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RequiredIndicatorModule } from '../required-indicator';
import { CheckboxComponent } from './checkbox.component';

@NgModule({
  declarations: [CheckboxComponent],
  imports: [CommonModule, RequiredIndicatorModule],
  exports: [CheckboxComponent],
})
export class CheckboxModule {}
